import type {
	Components,
} from '@mui/material'

export const materialUISwitchTheme: {
	components: Components
} = {
	components: {
		MuiSwitch: {
			styleOverrides: {
				switchBase: {

					/* color:primary */
					// [`&.${switchClasses.colorPrimary}.${switchClasses.checked} + .${switchClasses.track}`]: {
					// 	backgroundColor: 'var(--primary-color)',
					// },
					//
					// [`&.${switchClasses.colorPrimary}.${switchClasses.checked} .${switchClasses.thumb}`]: {
					// 	backgroundColor: 'var(--primary-color)',
					// },
					//
					// [`&.${switchClasses.colorPrimary} .MuiTouchRipple-root .MuiTouchRipple-child`]: {
					// 	backgroundColor: 'var(--primary-color)',
					// },
				},
			},
		},
	},
}
